import backend from '@/services/backend'

export default {

    /**
     * @param username
     * @param password
     */
    authenticateUserPassword (username, password, remember, realm) {
//        console.log('authenticateUserPassword: ' + username + ' / ' + password + ' / ' + remember)
        return backend({ method: 'post', url: 'auth/login', data: { username, password, remember, realm } })
    },

    // authenticateCookie (sessionId) {
    //     console.log('authenticateCookie: ' + sessionId)
    //     return backend({ method: 'post', url: 'vuejs/auth/validatecookie', data: { sessionId } })
    // },
    //
    // logout () {
    //     store.commit('logout')
    // }

    resetPassword(email) {
//        console.log('resetPassword: ' + email)
        return backend({ method: 'post', url: 'auth/reset', data: { email } })
    },

    setPassword(resetToken, password) {
//        console.log('setPassword: ' + password)
        return backend({ method: 'post', url: 'auth/setpwd', data: { token: resetToken, password: password } })
    },

    actAsUser( authToken, realmName, studyName, userId) {
        return backend.get('auth/actasuser/' + realmName + "/" + studyName + "/" + userId, { headers: { Authorization: authToken }} )
    },

    getInterviewDetails (authToken, realmName, studyName, externId) {
        // console.log('getInterviewDetails: ' + authToken)
        return backend.get('interview/details/' + realmName + "/" + studyName + "/" + externId, { headers: { Authorization: authToken }} )
    }

}
